import { GameLang } from "@lib/js-slingo-pawnshop-core/dist";
import { ControlPanelProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/ControlPanelProperties";
import { GameStyle } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/style/GameStyle";
import { OptionsProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/OptionsProperties";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { VerticalLayout } from "@lib/titan2/dist/game/control/layout/VerticalLayout";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractVerticalStakePanelProperties } from "@lib/titan2/dist/game/view/properties/AbstractStakePanelProperties";
import * as PIXI from "pixi.js";
import { Point } from "pixi.js";
/**
 * ControlPanelLandscapeProperties.ts
 */
export class ControlPanelLandscapeProperties extends ControlPanelProperties {
    equals(other) {
        return false;
    }
    constructor() {
        super();
        this.logoProperties.position = new PIXI.Point(1525, 118);
        this.logoProperties.scale.set(0.24);
        this.spinButtonPosition = new PIXI.Point(1533.5, 342.5);
        this.spinButtonProperties.circleRadius = 170;
        this.spinButtonProperties.trackingId = GameStyle.SPIN_BUTTON;
        this.purchaseSpinButtonProperties.disableAlign = true;
        this.purchaseSpinButtonProperties.textFieldProperties.verticalAlign = ControlConstants.BOTTOM;
        this.purchaseSpinButtonProperties.textFieldProperties.position = new PIXI.Point(136, 20);
        this.purchaseSpinButtonProperties.textFieldOffset = new PIXI.Point(0, 0);
        this.purchaseSpinButtonProperties.textFieldProperties.size = new PIXI.Point(231, 125);
        this.purchaseSpinButtonProperties.textFieldProperties.multiline = true;
        this.purchaseSpinButtonProperties.circleRadius = 170;
        this.purchaseSpinButtonProperties.disableTextAlpha = 0.6;
        this.startGameButtonProperties.circleRadius = 170;
        this.payTableButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_BUTTON, null, GameLang.OPTIONS_PAYS, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(150, 80));
        this.payTableButtonProperties.position.set(98, 1554);
        this.payTableButtonProperties.textFieldOffset.set(0, -2);
        this.payTableButtonProperties.textFieldProperties.fontProperties.trim = true;
        this.freeSpinButtonProperties.textFieldProperties.position = new PIXI.Point(200, 100);
        this.freeSpinButtonProperties.textFieldOffset = new PIXI.Point(0, 0);
        this.freeSpinButtonProperties.textFieldProperties.size = new PIXI.Point(200, 200);
        this.freeSpinButtonProperties.textFieldProperties.multiline = true;
        this.freeSpinButtonProperties.circleRadius = 200;
        this.spinPriceProperties.position = new PIXI.Point(136, 90);
        this.spinPriceProperties.size = new PIXI.Point(231, 150);
        this.collectButtonProperties.scale.set(1);
        this.collectButtonProperties.position = new PIXI.Point(638, 766);
        this.collectButtonProperties.movieClipProperties.scale.set(0.73);
        this.collectButtonProperties.disableAlign = true;
        this.collectButtonProperties.textFieldProperties.position.set(240, 20);
        this.collectButtonProperties.textFieldProperties.fontProperties.trim = true;
        this.collectButtonProperties.textFieldProperties.size = new PIXI.Point(350, 69);
        this.collectButtonProperties.disableTextAlpha = 1;
        this.collectButtonValueTextFieldProperties.position = new PIXI.Point(240, 70);
        this.collectButtonValueTextFieldProperties.fontProperties.trim = true;
        this.collectButtonValueTextFieldProperties.size = new PIXI.Point(350, 69);
        this.endGameButtonProperties.disableAlign = true;
        this.endGameButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.endGameButtonProperties.textFieldProperties.position.set(330, 45);
        this.endGameButtonProperties.movieClipProperties.scale.set(0.73);
        this.endGameButtonProperties.position = new PIXI.Point(638, 766);
        this.endGameButtonProperties.textFieldProperties.fontProperties.trim = true;
        this.endGameButtonProperties.textFieldProperties.size = new PIXI.Point(800, 69);
        Object.values(this.collectIcons).forEach(icon => {
            icon.position = new Point(1162, 940);
            icon.anchor = new Point(0.5, 1);
            icon.scale = new Point(0.25, 0.25);
        });
    }
}
/**
 * StakeSelectorLandscapeProperties.ts
 */
export class StakeSelectorLandscapeProperties extends AbstractVerticalStakePanelProperties {
    constructor() {
        super();
        this.position = new PIXI.Point(0, 0);
        this.scale.set(1);
        this.disabledPositionOffset = new PIXI.Point(0, 77);
        this.hasSeparateValuePanel = true;
        this.hideToggleButton = false;
        this.closeOnSelection = true;
        this.toggleButtonProperties.position.set(1427, 43.5);
        this.toggleButtonProperties.scale.set(0.67);
        this.panelProperties.layout = new VerticalLayout(-2);
        this.panelProperties.scale.set(0.84);
        this.panelProperties.position = new PIXI.Point(680, 54);
        this.valueButtonProperties.disableTextAlpha = 0;
        this.valueButtonProperties.textFieldProperties.size = new PIXI.Point(200, 100);
        this.valueButtonProperties.textFieldOffset.set(0, -7);
        this.toggleButtonProperties.trackingId = GameStyle.STAKE_BUTTON;
    }
    createToggleButtonTextFieldProperties() {
        super.createToggleButtonTextFieldProperties();
        this.toggleButtonProperties.textFieldProperties = null;
    }
}
/**
 * OptionsLandscapeProperties.ts
 */
export class OptionsLandscapeProperties extends OptionsProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundAlpha = 0.6;
        this.panelProperties.scale.set(0.8);
        this.optionsButtonProperties.position = new PIXI.Point(1768, 43.5);
        this.optionsButtonProperties.scale.set(0.67);
        this.optionsMenuProperties.position = new PIXI.Point(765, 110);
        this.optionsMenuProperties.spriteSheet = undefined;
        this.panelProperties.position = new PIXI.Point(-116, 20);
        let size = new PIXI.Point(500, 100);
        let textFieldOffset = new PIXI.Point(-235, 0);
        this.backgroundSoundButtonProperties.textFieldProperties.size = size;
        this.backgroundSoundButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.backgroundSoundButtonProperties.textFieldOffset = textFieldOffset;
        this.payTableButtonProperties.textFieldProperties.size = size;
        this.payTableButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.payTableButtonProperties.textFieldOffset = textFieldOffset;
        this.SFXButtonProperties.textFieldProperties.size = size;
        this.SFXButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.SFXButtonProperties.textFieldOffset = textFieldOffset;
        this.backgroundSoundButtonProperties.textFieldProperties.size = size;
        this.backgroundSoundButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.backgroundSoundButtonProperties.textFieldOffset = textFieldOffset;
        this.helpButtonProperties.textFieldProperties.size = size;
        this.helpButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.helpButtonProperties.textFieldOffset = textFieldOffset;
        this.homeButtonProperties.textFieldProperties.size = size;
        this.homeButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.homeButtonProperties.textFieldOffset = textFieldOffset;
        this.depositButtonProperties.textFieldProperties.size = size;
        this.depositButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.depositButtonProperties.textFieldOffset = textFieldOffset;
        this.dghButtonProperties.textFieldProperties.size = size;
        this.dghButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.dghButtonProperties.textFieldOffset = textFieldOffset;
        this.responsibleGamingButtonProperties.textFieldProperties.size = size;
        this.responsibleGamingButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.responsibleGamingButtonProperties.textFieldOffset = textFieldOffset;
        this.hasPayTable = false;
    }
}
